import { useGetOrganization } from "@/helpers/useGetOrganization.tsx";
import { useEffect, useRef } from "react";
import TagManager from "react-gtm-module";

const bookingEngineDiv = document.getElementById("bookingEngine");
const embedGtmId = bookingEngineDiv?.getAttribute("data-gtm_id") || import.meta.env.VITE_GTM_ID;

export const useGTMInit = () => {
  const { gtmKey } = useGetOrganization();
  const initialized = useRef(false);

  useEffect(() => {
    if (embedGtmId) return;
    if (!gtmKey || initialized.current) return;

    initialized.current = true;
    TagManager.initialize({ gtmId: gtmKey });
  }, [gtmKey]);
};
